import { useLazyQuery, useMutation } from "@apollo/client";
import React, { useContext, useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { clientPolicyIngsight } from "../../App";
import DropdownSingleSelectBlock from "../../components/DropdownSingleSelectBlock";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import MultipleChoiceAnswerBlock from "../../components/MultipleChoiceAnswerBlock";
import {
  CREATE_ANSWER_QUESTION_SURVEY,
  CREATE_FORM_QUESTION,
  CREATE_QUESTION_BANK,
  CREATE_QUESTION_SURVEY,
  UPDATE_DEPENDENCIES,
  UPDATE_FORM_QUESTION,
  UPDATE_FORM_QUESTION_STATUS,
  UPDATE_MANY_QUESTIONS,
  UPDATE_QUESTION_BANK,
  UPDATE_QUESTION_SURVEY,
} from "../../GraphQL/Mutations";
import { ALL_QUESTION_CATEGORIES } from "../../GraphQL/Queries";
import { ContextQuestions } from "../../Store/StoreQuestions";
import { messages } from "../../util/message";
import { getStateLogin } from "../LayoutHome/stateLogin";

const DropdownSingleSelectContainer = (globalProps) => {
  const { identity, dataSurvey } = globalProps;
  const [updateManyQuestions] = useMutation(UPDATE_MANY_QUESTIONS);
  const [stateQuestionsReducer, dispatch] = useContext(ContextQuestions);
  const [showLoader, setshowLoader] = useState(false);
  const [dependency, setdependency] = useState([]);
  const [title, setTitle] = useState("");
  const [mandatory, setMandatory] = useState(false);
  const [category, setCategory] = useState(0);
  const [validationMessage, setValidationMessage] = useState("");
  const [textAnswers, addTextAnswer] = useState([""]);
  const [, setBeforeText] = useState([""]);
  const [answers, addAnswer] = useState([]);
  const [beforeAnswers, setBeforeAnswers] = useState([]);
  const [missingFields, setMissingFields] = useState(false);
  const [showAddOther, setShowAddOther] = useState(true);
  const [categories, setcategories] = useState([]);
  const [createFormQuestion] = useMutation(CREATE_FORM_QUESTION, {
    client: clientPolicyIngsight,
  });
  const [updateFormQuestion] = useMutation(UPDATE_FORM_QUESTION, {
    client: clientPolicyIngsight,
  });
  const [updateFormQuestionStatus] = useMutation(UPDATE_FORM_QUESTION_STATUS, {
    client: clientPolicyIngsight,
  });
  const [createQuestionBank] = useMutation(CREATE_QUESTION_BANK);
  const [createQuestionSurvey] = useMutation(CREATE_QUESTION_SURVEY);
  const [updateQuestionBank] = useMutation(UPDATE_QUESTION_BANK);
  const [updateQuestionSurvey] = useMutation(UPDATE_QUESTION_SURVEY);
  const [createAnswerQuestionSurvey] = useMutation(
    CREATE_ANSWER_QUESTION_SURVEY
  );
  const [updateDependencies] = useMutation(UPDATE_DEPENDENCIES);
  const [showTooltipDescription, setShowTooltipDescription] = useState(false);
  const [tooltipInformationCheck, setTooltipInformationCheck] = useState(false);
  const [tooltipDescriptionText, setTooltipDescriptionText] = useState("");
  const [configQuestionStyle, setconfigQuestionStyle] = useState({
    question: {
      fontFamily: "",
      fontWeight: "",
      fontStyle: "",
      textDecoration: "",
      fontSize: "",
      color: "",
    },
    answer: {
      fontFamily: "",
      fontWeight: "",
      fontStyle: "",
      textDecoration: "",
      fontSize: "",
      color: "",
    },
    customStyle: false,
    background: "",
    alignment: "",
    typeQuestion: "DropdownSingleSelect",
    caranswerListitas: [""],
    tooltip: {
      status: tooltipInformationCheck,
      descriptionText: tooltipDescriptionText,
    },
  });

  const changeTooltipInformationCheck = (status) => {
    configQuestionStyle.tooltip.status = status;
    let newConfigQuestionStyle = configQuestionStyle;
    setconfigQuestionStyle(newConfigQuestionStyle);
    setTooltipInformationCheck(status);
  };

  const [getQuestionCategories, { error: errorCat, loading: loadingCat }] =
    useLazyQuery(ALL_QUESTION_CATEGORIES, {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (!data.allCategoriesQuestion.withError) {
          const allCategories = data.allCategoriesQuestion.outputData.map(
            (c) => ({ ...c })
          );
          if (dataSurvey?.isGlobal) {
            setcategories(
              allCategories.filter((f) => f.description === "Global")
            );
          } else {
            setcategories(
              allCategories.filter((f) => f.description !== "Global")
            );
          }
        }
      },
    });

  useEffect(() => {
    if (globalProps.GjsonConfiguration !== "") {
      const parsedJSON = JSON.parse(globalProps.GjsonConfiguration);
      if (parsedJSON.tooltip) {
        setTooltipInformationCheck(parsedJSON.tooltip.status);
        setTooltipDescriptionText(parsedJSON.tooltip.descriptionText);
      }
    }
  }, []);

  useEffect(() => {
    if (globalProps.GidQuestionSurvey) {
      let jsonConfSurveyQuestion = JSON.parse(globalProps.GjsonConfiguration);
      setMandatory(
        globalProps.GisMandatory && globalProps.GisMandatory !== null
          ? globalProps.GisMandatory
          : false
      );
      setValidationMessage(globalProps.GvalidationText);

      setTitle(globalProps.GnameQuestion);
      setCategory(globalProps.GidCategoryQuestion);

      addTextAnswer(jsonConfSurveyQuestion.answerList);
      setconfigQuestionStyle(jsonConfSurveyQuestion);
      setBeforeText();
      addAnswer();
      setBeforeAnswers();
      setMissingFields();

      setdependency(
        stateQuestionsReducer.questions
          .filter((f) => f.GidParentQuestion === globalProps.GidQuestionSurvey)
          .map((q) => {
            return {
              idQuestionSurvey: q.GidQuestionSurvey,
              isDependent: q.GisDependent,
              idParentQuestion: q.GidParentQuestion,
              dependentAnswer: q.GdependentAnswer,
            };
          })
      );
    }
    getQuestionCategories();
  }, []);

  useEffect(() => {
    if (textAnswers.length > 0) {
      setShowAddOther(textAnswers.filter((i) => i === "Other").length === 0);
      let newArray = [];
      textAnswers.forEach((item, index) => {
        newArray = [
          ...newArray,
          <MultipleChoiceAnswerBlock
            key={index + 1}
            arrIndex={index}
            textAnswers={textAnswers}
            type={"radio"}
            other={textAnswers[index] === "Other"}
            dependency={dependency}
          />,
        ];
      });
      addAnswer(newArray);
    }
  }, [textAnswers]);

  useEffect(() => {
    if (!globalProps.GidQuestionSurvey) {
      addAnswer([
        <MultipleChoiceAnswerBlock
          key={1}
          arrIndex={answers.length}
          textAnswers={textAnswers}
          type={"radio"}
          other={false}
        />,
      ]);
    }
  }, []);

  const OrderQuestions = () => {
    let data = [];
    stateQuestionsReducer.questions.forEach((question, index) => {
      question.Gorder = index + 1;
      question.GindexQuestion = index;
      data.push({
        idQuestionSurvey: question.GidQuestionSurvey,
        order: question.Gorder,
        idQuestion: question.GidQuestion,
      });
    });
    updateManyQuestions({
      variables: {
        questions: { questionSurveys: data },
      },
    }).then((response) => {
      if (response.data.updateManyQuestionSurvey.withError) {
        NotificationManager.error("Error updating questions", "", 5000);
      } else {
        let copy = JSON.parse(JSON.stringify(stateQuestionsReducer));
        dispatch({ type: "CLEAN_QUESTIONS" });
        dispatch({ type: "DELETE_QUESTIONS", payload: copy });
      }
      setshowLoader(false);
    });
  };

  let saveQuestionSurvey = (idQuestion, copyText) => {
    setshowLoader(true);
    configQuestionStyle.answerList = textAnswers;
    createQuestionSurvey({
      variables: {
        idQuestion: idQuestion,
        idSurvey: globalProps.GidSurvey,
        order: globalProps.Gorder,
        isMandatory: mandatory,
        jsonConfiguration: JSON.stringify(configQuestionStyle),
        active: true,
        createUser: getStateLogin(),
      },
    }).then((response) => {
      if (copyText !== "") {
        dispatch({
          type: "CLONE_QUESTION",
          payload: {
            Gtype: "DropdownSingleSelect",
            GindexQuestion: globalProps.GindexQuestion + 1,
            Gactive: true,
            GidSurvey: globalProps.GidSurvey,
            GidQuestion: idQuestion,
            GidCategoryQuestion: category,
            GnameQuestion: title + copyText,
            GvalidationText: validationMessage,
            GidQuestionSurvey: response.data.createQuestionSurvey,
            GisMandatory: mandatory,
            GjsonConfiguration: JSON.stringify(configQuestionStyle),
            Gorder: globalProps.Gorder + 1,
            GisEdit: false,
            GisDependent: false,
            GidParentQuestion: null,
            GdependentAnswer: null,
            clonePosition: globalProps.GindexQuestion + 1,
          },
        });
      } else {
        dispatch({
          type: "SAVE_QUESTIONS",
          payload: {
            GindexQuestion: globalProps.GindexQuestion,
            GisEdit: false,
            GnameQuestion: title,
            GidCategoryQuestion: category,
            GisMandatory: mandatory,
            Gorder: globalProps.Gorder,
            GvalidationText: validationMessage,
            GidQuestion: idQuestion,
            GidQuestionSurvey: response.data.createQuestionSurvey,
            GjsonConfiguration: JSON.stringify(configQuestionStyle),
          },
        });
      }
      createAnswerQuestionSurvey({
        variables: {
          idQuestionSurvey: response.data.createQuestionSurvey,
          idCategoryAnswer: 7,
          createUser: getStateLogin(),
        },
      });

      if (dependency.length) {
        dependency.forEach(
          (d) => (d.idParentQuestion = response.data.createQuestionSurvey)
        );
        updateDependencies({
          variables: {
            dependencies: dependency,
          },
        }).then((response) => {
          if (response.data.updateQuestionSurveyDependencies.withError) {
            NotificationManager.error("Error to save dependencies", "", 5000);
            setshowLoader(false);
          } else {
            dependency
              .sort((a, b) => {
                if (a.dependentAnswer < b.dependentAnswer) {
                  return -1;
                }
                if (a.dependentAnswer > b.dependentAnswer) {
                  return 1;
                }
                return 0;
              })
              .forEach((d) => {
                let position = stateQuestionsReducer.questions.findIndex(
                  (i) => i.GidQuestionSurvey === d.idQuestionSurvey
                );
                dispatch({
                  type: "UPDATE_QUESTIONS_DEPENDENCY",
                  payload: {
                    GindexQuestion: position,
                    GidQuestionSurvey: d.idQuestionSurvey,
                    GisDependent: d.isDependent,
                    GidParentQuestion: d.idParentQuestion,
                    GdependentAnswer: d.dependentAnswer,
                  },
                });
                const [reorderedItem] = stateQuestionsReducer.questions.splice(
                  position,
                  1
                );
                stateQuestionsReducer.questions.splice(
                  stateQuestionsReducer.questions.findIndex(
                    (f) => f.GidQuestionSurvey === globalProps.GidQuestionSurvey
                  ) + 1,
                  0,
                  reorderedItem
                );
              });
            OrderQuestions();
          }
        });
      } else {
        setshowLoader(false);
      }
    });
  };

  let updateInQuestionSurvey = (idInBank) => {
    setshowLoader(true);
    configQuestionStyle.answerList = textAnswers;
    updateQuestionSurvey({
      variables: {
        idQuestionSurvey: globalProps.GidQuestionSurvey,
        idQuestion: idInBank,
        idSurvey: globalProps.GidSurvey,
        order: globalProps.Gorder,
        isMandatory: mandatory,
        jsonConfiguration: JSON.stringify(configQuestionStyle),
        active: true,
        lastUpdateUser: getStateLogin(),
      },
    }).then((response) => {
      dispatch({
        type: "UPDATE_QUESTIONS",
        payload: {
          GindexQuestion: globalProps.GindexQuestion,
          GisEdit: false,
          GnameQuestion: title,
          GidCategoryQuestion: category,
          GisMandatory: mandatory,
          Gorder: globalProps.Gorder,
          GvalidationText: validationMessage,
          GjsonConfiguration: JSON.stringify(configQuestionStyle),
        },
      });
      if (dependency.length) {
        updateDependencies({
          variables: {
            dependencies: dependency,
          },
        }).then((response) => {
          if (response.data.updateQuestionSurveyDependencies.withError) {
            NotificationManager.error("Error to save dependencies", "", 5000);
            setshowLoader(false);
          } else {
            dependency
              .sort((a, b) => {
                if (a.dependentAnswer < b.dependentAnswer) {
                  return -1;
                }
                if (a.dependentAnswer > b.dependentAnswer) {
                  return 1;
                }
                return 0;
              })
              .forEach((d) => {
                let position = stateQuestionsReducer.questions.findIndex(
                  (i) => i.GidQuestionSurvey === d.idQuestionSurvey
                );
                dispatch({
                  type: "UPDATE_QUESTIONS_DEPENDENCY",
                  payload: {
                    GindexQuestion: position,
                    GidQuestionSurvey: d.idQuestionSurvey,
                    GisDependent: d.isDependent,
                    GidParentQuestion: d.idParentQuestion,
                    GdependentAnswer: d.dependentAnswer,
                  },
                });
                const [reorderedItem] = stateQuestionsReducer.questions.splice(
                  position,
                  1
                );
                stateQuestionsReducer.questions.splice(
                  stateQuestionsReducer.questions.findIndex(
                    (f) => f.GidQuestionSurvey === globalProps.GidQuestionSurvey
                  ) + 1,
                  0,
                  reorderedItem
                );
              });
            OrderQuestions();
          }
        });
      } else {
        setshowLoader(false);
      }
    });
  };

  const updateQuestion = () => {
    configQuestionStyle.answerList = textAnswers;
    configQuestionStyle.validationText = mandatory ? validationMessage : "";
    updateFormQuestion({
      variables: {
        idQuestionForm: globalProps.GidQuestion,
        questionTitle: title,
        questionType: "DROPDOWN_SINGLE_SELECT",
        isMandatory: mandatory,
        questionOrder: globalProps.Gorder,
        jsonConfiguration: JSON.stringify(configQuestionStyle),
      },
    })
      .then((res) => {
        dispatch({
          type: "UPDATE_QUESTIONS",
          payload: {
            GindexQuestion: globalProps.GindexQuestion,
            GisEdit: false,
            GnameQuestion: title,
            GidCategoryQuestion: "",
            GisMandatory: mandatory,
            Gorder: globalProps.Gorder,
            GvalidationText: mandatory ? validationMessage : "",
            GjsonConfiguration: JSON.stringify(configQuestionStyle),
          },
        });
        setshowLoader(false);
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };
  const createQuestion = (clone) => {
    let copyText = clone ? " - Copy" : "";
    configQuestionStyle.answerList = textAnswers;
    configQuestionStyle.validationText = mandatory ? validationMessage : "";
    createFormQuestion({
      variables: {
        idForm: globalProps.GidSurvey,
        questionTitle: title + copyText,
        questionType: "DROPDOWN_SINGLE_SELECT",
        jsonConfiguration: JSON.stringify(configQuestionStyle),
        isMandatory: mandatory,
        questionOrder: globalProps.Gorder,
      },
    })
      .then((res) => {
        if (res?.data?.createFormQuestion?.idForm) {
          let idQuestion = res.data.createFormQuestion.idQuestionForm;
          if (copyText !== "") {
            dispatch({
              type: "CLONE_QUESTION",
              payload: {
                Gtype: "DropdownSingleSelect",
                GindexQuestion: globalProps.GindexQuestion + 1,
                Gactive: true,
                GidSurvey: globalProps.GidSurvey,
                GidQuestion: idQuestion,
                GidCategoryQuestion: "",
                GnameQuestion: title + copyText,
                GvalidationText: mandatory ? validationMessage : "",
                GidQuestionSurvey: idQuestion,
                GisMandatory: mandatory,
                GjsonConfiguration: JSON.stringify(configQuestionStyle),
                Gorder: globalProps.Gorder + 1,
                GisEdit: false,
                GisDependent: false,
                GidParentQuestion: null,
                GdependentAnswer: null,
                clonePosition: globalProps.GindexQuestion + 1,
              },
            });
          } else {
            dispatch({
              type: "SAVE_QUESTIONS",
              payload: {
                GindexQuestion: globalProps.GindexQuestion,
                GisEdit: false,
                GnameQuestion: title,
                GidCategoryQuestion: "",
                GisMandatory: mandatory,
                Gorder: globalProps.Gorder,
                GvalidationText: mandatory ? validationMessage : "",
                GidQuestion: idQuestion,
                GidQuestionSurvey: idQuestion,
                GjsonConfiguration: JSON.stringify(configQuestionStyle),
              },
            });
          }
          setshowLoader(false);
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };
  const saveFormQuestion = (clone) => {
    let allAnsCompleted =
      textAnswers.filter((i) => i != "").length === answers.length
        ? true
        : false;
    setMissingFields(!allAnsCompleted);
    if (
      title.trim() !== "" &&
      allAnsCompleted &&
      ((mandatory && validationMessage.trim() !== "") ||
        (tooltipInformationCheck && tooltipDescriptionText.trim() !== "") ||
        !mandatory ||
        !tooltipInformationCheck)
    ) {
      if (
        !tooltipInformationCheck ||
        (tooltipInformationCheck && tooltipDescriptionText !== "")
      ) {
        setshowLoader(true);
        if (mandatory && validationMessage !== "") {
          if (globalProps.GidQuestionSurvey && !clone) {
            updateQuestion();
          } else {
            createQuestion(clone);
          }
        } else {
          if (!mandatory) {
            if (globalProps.GidQuestionSurvey && !clone) {
              updateQuestion();
            } else {
              createQuestion(clone);
            }
          } else if (mandatory && validationMessage === "") {
            if (globalProps.GidQuestionSurvey && !clone) {
              updateQuestion();
            } else {
              createQuestion(clone);
            }
          }
        }
      } else {
        handleNoTooltipDesMessage();
      }
    } else {
      handleNoQuestionTitle();
      handleNoMandatoryText();
      handleNoTooltipDesMessage();
    }
  };

  let saveQuestionBank = (clone) => {
    let allAnsCompleted =
      textAnswers.filter((i) => i != "").length === answers.length
        ? true
        : false;
    setMissingFields(!allAnsCompleted);
    if (
      title.trim() !== "" &&
      parseInt(category) !== 0 &&
      allAnsCompleted &&
      ((mandatory && validationMessage.trim() !== "") ||
        (tooltipInformationCheck && tooltipDescriptionText !== "") ||
        !mandatory ||
        !tooltipInformationCheck)
    ) {
      if (
        !tooltipInformationCheck ||
        (tooltipInformationCheck && tooltipDescriptionText !== "")
      ) {
        setshowLoader(true);
        let copyText = clone ? " - Copy" : "";
        if (mandatory && validationMessage !== "") {
          if (globalProps.GidQuestionSurvey && !clone) {
            updateQuestionBank({
              variables: {
                idQuestion: globalProps.GidQuestion,
                nameQuestion: title,
                validationText: validationMessage,
                idCategoryQuestion: parseInt(category),
                active: true,
                lastUpdateUser: getStateLogin(),
              },
            }).then(() => {
              updateInQuestionSurvey(globalProps.GidQuestion);
            });
          } else {
            createQuestionBank({
              variables: {
                nameQuestion: title + copyText,
                validationText: validationMessage,
                idCategoryQuestion: parseInt(category),
                active: true,
                createUser: getStateLogin(),
              },
            }).then((saveResponse) => {
              saveQuestionSurvey(
                saveResponse.data.createQuestionBank,
                copyText
              );
            });
          }
        } else {
          if (!mandatory) {
            if (globalProps.GidQuestionSurvey && !clone) {
              updateQuestionBank({
                variables: {
                  idQuestion: globalProps.GidQuestion,
                  nameQuestion: title,
                  validationText: "",
                  idCategoryQuestion: parseInt(category),
                  active: true,
                  lastUpdateUser: getStateLogin(),
                },
              })
                .then(() => {
                  updateInQuestionSurvey(globalProps.GidQuestion);
                })
                .catch((error) => {
                  setshowLoader(false);
                  const errorMessage = error.message.split("\n")[0];
                  NotificationManager.error(errorMessage, "", 5000);
                });
            } else {
              createQuestionBank({
                variables: {
                  nameQuestion: title + copyText,
                  validationText: "",
                  idCategoryQuestion: parseInt(category),
                  active: true,
                  createUser: getStateLogin(),
                },
              })
                .then((saveResponse) => {
                  saveQuestionSurvey(
                    saveResponse.data.createQuestionBank,
                    copyText
                  );
                })
                .catch((error) => {
                  setshowLoader(false);
                  const errorMessage = error.message.split("\n")[0];
                  NotificationManager.error(errorMessage, "", 5000);
                });
            }
          } else if (mandatory && validationMessage === "") {
            if (globalProps.GidQuestionSurvey && !clone) {
              updateQuestionBank({
                variables: {
                  idQuestion: globalProps.GidQuestion,
                  nameQuestion: title,
                  validationText: validationMessage,
                  idCategoryQuestion: parseInt(category),
                  active: true,
                  lastUpdateUser: getStateLogin(),
                },
              })
                .then(() => {
                  updateInQuestionSurvey(globalProps.GidQuestion);
                })
                .catch((error) => {
                  setshowLoader(false);
                  const errorMessage = error.message.split("\n")[0];
                  NotificationManager.error(errorMessage, "", 5000);
                });
            } else {
              createQuestionBank({
                variables: {
                  nameQuestion: title + copyText,
                  validationText: validationMessage,
                  idCategoryQuestion: parseInt(category),
                  active: true,
                  createUser: getStateLogin(),
                },
              })
                .then((saveResponse) => {
                  saveQuestionSurvey(
                    saveResponse.data.createQuestionBank,
                    copyText
                  );
                })
                .catch((error) => {
                  setshowLoader(false);
                  const errorMessage = error.message.split("\n")[0];
                  NotificationManager.error(errorMessage, "", 5000);
                });
            }
          }
        }
      } else {
        handleNoTooltipDesMessage();
      }
    } else {
      handleNoQuestionTitle();
      handleNoCategory();
      handleNoMandatoryText();
      handleNoTooltipDesMessage();
    }
  };

  let handleNoQuestionTitle = () => {
    if (title.trim() === "") {
      NotificationManager.warning(messages.QuestionTitle);
    }
  };

  let handleNoCategory = () => {
    if (parseInt(category) === 0) {
      NotificationManager.warning(messages.QuestionCategory);
    }
  };

  let handleNoMandatoryText = () => {
    if (mandatory && validationMessage.trim() === "") {
      NotificationManager.warning(messages.QuestionMandatory);
    }
  };

  let handleNoTooltipDesMessage = () => {
    if (tooltipInformationCheck && tooltipDescriptionText === "") {
      NotificationManager.warning(messages.QuestionTooltipDescription);
    }
  };

  let handleEdit = () => {
    if (
      stateQuestionsReducer.questions.filter((f) => f.GisEdit === true).length
    ) {
      NotificationManager.warning(
        "All questions must be saved before to edit another question",
        "",
        5000
      );
      return;
    }
    dispatch({
      type: "EDIT_QUESTIONS",
      payload: {
        GindexQuestion: globalProps.GindexQuestion,
        GisEdit: true,
      },
    });
    setBeforeAnswers(answers);
    setBeforeText(textAnswers);
  };
  let handleCancel = () => {
    let objG = stateQuestionsReducer.questions[globalProps.GindexQuestion];
    let jsonConfSurveyQuestion = JSON.parse(objG.GjsonConfiguration);

    setMandatory(
      objG.GisMandatory && objG.GisMandatory !== null
        ? objG.GisMandatory
        : false
    );
    setValidationMessage(objG.GvalidationText);
    setTitle(objG.GnameQuestion);
    setCategory(objG.GidCategoryQuestion);
    addTextAnswer(jsonConfSurveyQuestion.answerList);
    setconfigQuestionStyle(jsonConfSurveyQuestion);
    setdependency(
      stateQuestionsReducer.questions
        .filter((f) => f.GidParentQuestion === globalProps.GidQuestionSurvey)
        .map((q) => {
          return {
            idQuestionSurvey: q.GidQuestionSurvey,
            isDependent: q.GisDependent,
            idParentQuestion: q.GidParentQuestion,
            dependentAnswer: q.GdependentAnswer,
          };
        })
    );
    setMissingFields();

    if (jsonConfSurveyQuestion.tooltip) {
      setTooltipInformationCheck(jsonConfSurveyQuestion.tooltip.status);
      setTooltipDescriptionText(jsonConfSurveyQuestion.tooltip.descriptionText);
    }

    dispatch({
      type: "CANCEL_QUESTIONS",
      payload: {
        GindexQuestion: globalProps.GindexQuestion,
        GisEdit: false,
      },
    });

    addAnswer(beforeAnswers);
  };

  let handleAdd = () => {
    addAnswer([
      ...answers,
      <MultipleChoiceAnswerBlock
        key={answers.length + 1}
        arrIndex={answers.length}
        textAnswers={textAnswers}
        type={"radio"}
        other={false}
      />,
    ]);
    textAnswers.push("");
  };

  let handleAddOther = () => {
    addAnswer([
      ...answers,
      <MultipleChoiceAnswerBlock
        key={answers.length + 1}
        arrIndex={answers.length}
        textAnswers={textAnswers}
        type={"radio"}
        other={true}
      />,
    ]);
    textAnswers.push("Other");
    setShowAddOther(false);
  };

  let handleDeleteOther = () => {
    let newAns = [...answers.filter((i) => i.props.other !== true)];
    let newText = [...textAnswers];
    newText.splice(newText.indexOf("Other"), 1);
    addAnswer(newAns);
    addTextAnswer(newText);
    setShowAddOther(true);
  };

  let handleDelete = () => {
    let newAns = [...answers.filter((i) => i.props.other !== true)];
    let newText = [...textAnswers.filter((i) => i !== "Other")];

    dependency
      .filter((f) => f.dependentAnswer === textAnswers[textAnswers.length - 1])
      .forEach((q) => {
        q.isDependent = false;
        q.idParentQuestion = null;
        q.dependentAnswer = null;
      });

    newAns.splice(-1, 1);
    newText.splice(-1, 1);

    let other = answers.filter((i) => i.props.other === true)[0];
    let textOther = textAnswers.filter((i) => i === "Other")[0];
    if (other) {
      newAns.push(other);
    }
    if (textOther) {
      newText.push(textOther);
    }

    addAnswer([...newAns]);
    addTextAnswer([...newText]);
  };

  const deleteNonSavedQuestion = () => {
    setshowLoader(false);
    let copy = JSON.parse(JSON.stringify(stateQuestionsReducer));
    copy.questions.splice(globalProps.GindexQuestion, 1);
    copy.questions.map((q, index) => {
      q.GindexQuestion = index;
      q.Gorder = index + 1;
    });
    dispatch({ type: "CLEAN_QUESTIONS" });
    dispatch({ type: "DELETE_QUESTIONS", payload: copy });
  };

  const handleDeleteFormQuestion = () => {
    setshowLoader(true);
    if (globalProps.GidQuestion) {
      updateFormQuestionStatus({
        variables: {
          idFormQuestion: globalProps.GidQuestion,
          newFormQuestionStatus: "DELETED",
        },
      })
        .then((res) => {
          if (res?.data?.changeStatusFormQuestion?.idQuestionForm) {
            setshowLoader(false);
            let copy = JSON.parse(JSON.stringify(stateQuestionsReducer));
            copy.questions.splice(globalProps.GindexQuestion, 1);
            copy.questions.forEach((q, index) => {
              q.GindexQuestion = index;
              q.Gorder = index + 1;
            });
            dispatch({ type: "CLEAN_QUESTIONS" });
            dispatch({ type: "DELETE_QUESTIONS", payload: copy });
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else {
      deleteNonSavedQuestion();
    }
  };

  let handleDeleteQuestion = () => {
    setshowLoader(true);
    if (globalProps.GidQuestionSurvey !== 0) {
      updateQuestionBank({
        variables: {
          idQuestion: globalProps.GidQuestion,
          active: false,
          lastUpdateUser: getStateLogin(),
        },
      }).then((result) => {
        updateQuestionSurvey({
          variables: {
            idQuestionSurvey: globalProps.GidQuestionSurvey,
            idQuestion: globalProps.GidQuestion,
            idSurvey: globalProps.GidSurvey,
            jsonConfiguration: "",
            isMandatory: false,
            order: 0,
            active: false,
            lastUpdateUser: getStateLogin(),
          },
        }).then((resultUpdate) => {
          setshowLoader(false);
          let copy = JSON.parse(JSON.stringify(stateQuestionsReducer));
          copy.questions.splice(globalProps.GindexQuestion, 1);
          copy.questions.forEach((q, index) => {
            if (q.GidParentQuestion === globalProps.GidQuestionSurvey) {
              q.GdependentAnswer = "";
              q.GidParentQuestion = 0;
              q.GisDependent = false;
            }
            q.GindexQuestion = index;
            q.Gorder = index + 1;
          });
          dispatch({ type: "CLEAN_QUESTIONS" });
          dispatch({ type: "DELETE_QUESTIONS", payload: copy });
        });
      });
    } else {
      deleteNonSavedQuestion();
    }
  };

  const saveDependencies = (Questions) => {
    setdependency(Questions);
  };

  let handleTextAreaText = (value) => {
    setTooltipDescriptionText(value);
    configQuestionStyle.tooltip.descriptionText = value;
    let newConfigQuestionStyle = configQuestionStyle;
    setconfigQuestionStyle(newConfigQuestionStyle);
  };

  return (
    <>
      <DropdownSingleSelectBlock
        alreadySaved={globalProps.GisEdit ? false : true}
        editable={globalProps.GisEdit}
        title={title}
        setTitle={setTitle}
        mandatory={mandatory}
        setMandatory={setMandatory}
        loadingCat={loadingCat}
        errorCat={errorCat}
        categories={categories}
        category={category}
        setCategory={setCategory}
        validationText={validationMessage}
        setValidationMessage={setValidationMessage}
        saveQuestionBank={saveQuestionBank}
        handleEdit={handleEdit}
        handleCancel={handleCancel}
        answers={answers}
        addAnswer={addAnswer}
        handleAdd={handleAdd}
        handleAddOther={handleAddOther}
        handleDelete={handleDelete}
        missingFields={missingFields}
        configQuestionStyle={configQuestionStyle}
        setconfigQuestionStyle={setconfigQuestionStyle}
        handleDeleteQuestion={() => {
          if (identity !== "form") {
            handleDeleteQuestion();
          } else {
            handleDeleteFormQuestion();
          }
        }}
        showAddOther={showAddOther}
        handleDeleteOther={handleDeleteOther}
        idQuestionSurvey={globalProps.GidQuestionSurvey}
        saveDependencies={saveDependencies}
        dependency={dependency}
        globalProps={globalProps}
        dropdownValues={textAnswers}
        identity={identity}
        saveFormQuestion={saveFormQuestion}
        tooltipInformationCheck={tooltipInformationCheck}
        tooltipDescriptionText={tooltipDescriptionText}
        setShowTooltipDescription={setShowTooltipDescription}
        handleTextAreaText={handleTextAreaText}
        changeTooltipInformationCheck={changeTooltipInformationCheck}
        showTooltipDescription={showTooltipDescription}
      />
      {showLoader && <ModalLoader></ModalLoader>}
    </>
  );
};

export default DropdownSingleSelectContainer;
